import { getError } from "@/utils/helpers";
import StatuteService from "@/services/statute/StatuteService";

export const namespaced = true;

export const state = {
  members: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_MEMBERS(state, members) {
    state.members = members;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getMembers({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteService.getMembers(famId)
      .then((response) => {
        commit("SET_MEMBERS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_MEMBERS", []);
  },
};
export const getters = {
  members: (state) => {
    return state.members;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
